import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { executeApiAction } from '../../shared/utility/apiHelper';
import { getMyCorrectionRequests } from '../services/evidenceService';

const useMyCorrectionRequests = () => {
  const dispatch = useDispatch();
  const [corrections, setCorrections] = useState([]);
  const [correctionsLoading, setCorrectionsLoading] = useState(false);

  const loadCorrections = useCallback(() => {
    executeApiAction({
      setLoading: setCorrectionsLoading,
      dispatch,
      action: () => getMyCorrectionRequests(),
      onSuccess: (response) => setCorrections(response || []),
    });
  }, [dispatch]);

  useEffect(() => {
    loadCorrections();
  }, [loadCorrections]);

  return { corrections, correctionsLoading, refetchCorrections: loadCorrections };
};

export default useMyCorrectionRequests;
